import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 0.7; }
  100% { opacity: 0.35; }
`;

// Mirrors FanCamLivePlayerSkeleton.tsx exactly: dark full stage, top-right
// "--- views" pill, bottom shimmer placeholders for header/caption/actions.
const Stage = styled.div`
  position: relative;
  flex: 1;
  min-height: 480px;
  margin: 0 16px 16px;
  border-radius: 16px;
  overflow: hidden;
  background-color: #000;
`;

const TopBar = styled.div`
  position: absolute;
  top: 8px;
  right: 16px;
`;

const ViewCountGroup = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 4px 12px;
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
`;

const BottomContent = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Shimmer = styled.div`
  background-color: rgba(255, 255, 255, 0.15);
  animation: ${shimmer} 1.4s ease-in-out infinite;
  border-radius: ${(props) => props.$radius || '7px'};
  width: ${(props) => props.$w};
  height: ${(props) => props.$h};
  flex: ${(props) => props.$flex};
`;

const Dot = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 1.5px;
  background-color: rgba(255, 255, 255, 0.3);
`;

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
`;

const ReferralFeedSkeleton = () => (
  <Stage>
    <TopBar>
      <ViewCountGroup>👁 --- views</ViewCountGroup>
    </TopBar>
    <BottomContent>
      <HeaderRow>
        <Shimmer $w="64px" $h="14px" />
        <Dot />
        <Shimmer $w="88px" $h="14px" />
        <Dot />
        <Shimmer $w="64px" $h="14px" />
      </HeaderRow>
      <Shimmer $w="100%" $h="44px" $radius="12px" style={{ marginTop: 12 }} />
      <ActionsRow>
        {[0, 1, 2, 3].map((i) => (
          <Shimmer key={i} $flex="1" $h="36px" $radius="18px" />
        ))}
      </ActionsRow>
    </BottomContent>
  </Stage>
);

export default ReferralFeedSkeleton;
